import React from 'react'
import styles from './MainLayout.module.scss'

import SideBar from '../../../common/components/organisme/SideBar/SideBar'

export interface MainLayoutProps {
  children?: React.ReactNode
  isNoSideBar?: boolean
  sideBar?: React.ReactNode

}

export default function MainLayout({children}: MainLayoutProps) {


  return (
    <div className={styles['layout']}>

      <div className={styles['sidebar']}>
        <div className={styles['sidebar__content']}>
        <SideBar />
        </div>

      </div>
    <div className={styles['layout__content']}>
      

    {children}
    </div>
    </div>


  )
}
